var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPptIcon = function SvgPptIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    stroke: "#5E5D5D",
    strokeWidth: 0.2,
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 4,
    fill: "#5D5C5C",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 12
  }, "PPT")), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.217 1A.218.218 0 0 0 1 1.22V14.78c0 .121.097.219.217.219h10.334c.12 0 .217-.098.217-.219v-9.34a.22.22 0 0 0-.061-.154L7.634 1.085v-.001a.218.218 0 0 0-.016-.017.218.218 0 0 0-.14-.065A.232.232 0 0 0 7.467 1h-6.25Zm.217.437H7.37l3.965 4.092v9.034h-9.9V1.437Z",
    stroke: "#5D5C5C",
    strokeWidth: 0.2,
    fill: "#5D5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.455 1a.218.218 0 0 0-.21.219V5.44c0 .121.097.219.217.219h4.089a.22.22 0 0 0 .156-.372l-4.09-4.22A.217.217 0 0 0 7.456 1Zm.224.758 3.358 3.464H7.679V1.758Z",
    fill: "#5F5E5E"
  })))));
};
export default SvgPptIcon;